var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconEducation64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_17518)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1452 8.50269C34.0849 8.50269 35.6574 10.0751 35.6574 12.0149V15.527H28.6331V12.0149C28.6331 10.0751 30.2055 8.50269 32.1452 8.50269Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3658 13.1863H40.9267C46.0992 13.1863 50.2924 17.3795 50.2924 22.5521V51.8202C50.2924 54.4065 48.1958 56.5031 45.6095 56.5031H18.6829C16.0966 56.5031 14 54.4065 14 51.8202V22.5521C14 17.3795 18.1932 13.1863 23.3658 13.1863Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1455 18.2727L37.1125 23.1459L32.1455 28.0192L27.1785 23.1459L32.1455 18.2727Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4395 36.6038H21.025C19.7319 36.6038 18.6836 37.6521 18.6836 38.9452V49.4817C18.6836 50.7749 19.7319 51.8232 21.025 51.8232H44.4395C45.7327 51.8232 46.781 50.7749 46.781 49.4817V38.9452C46.781 37.6521 45.7327 36.6038 44.4395 36.6038Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2659 41.2874H46.1925",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9243 41.8696V44.2111",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_17518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconEducation64);
export default __webpack_public_path__ + "static/media/pictogramBeaconEducation64.09672c06d16d344cff6115f8cdf883cd.svg";
export { ForwardRef as ReactComponent };